module.exports = __webpack_public_path__ + "static/media/toalett.60e55c0f.png";